import { render, staticRenderFns } from "./NavIndex.vue?vue&type=template&id=f72bf32c&scoped=true&"
import script from "./NavIndex.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./NavIndex.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./NavIndex.vue?vue&type=style&index=0&id=f72bf32c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72bf32c",
  null
  
)

export default component.exports